/*****************************************************************************
 * Open MCT, Copyright (c) 2014-2018, United States Government
 * as represented by the Administrator of the National Aeronautics and Space
 * Administration. All rights reserved.
 *
 * Open MCT is licensed under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations
 * under the License.
 *
 * Open MCT includes source code licensed under additional open source
 * licenses. See the Open Source Licenses file (LICENSES.md) included with
 * this source code distribution or the Licensing information page available
 * at runtime from the About dialog for additional information.
 *****************************************************************************/

define(
    'platform/core/src/models/CachingModelDecorator',[],
    function () {

        /**
         * The caching model decorator maintains a cache of loaded domain
         * object models, and ensures that duplicate models for the same
         * object are not provided.
         * @memberof platform/core
         * @constructor
         * @param {ModelService} modelService this service to decorate
         * @implements {ModelService}
         */
        function CachingModelDecorator(cacheService, modelService) {
            this.cacheService = cacheService;
            this.modelService = modelService;
        }

        CachingModelDecorator.prototype.getModels = function (ids) {
            var loadFromCache = ids.filter(function cached(id) {
                    return this.cacheService.has(id);
                }, this),
                loadFromService = ids.filter(function notCached(id) {
                    return !this.cacheService.has(id);
                }, this);

            if (!loadFromCache.length) {
                return this.modelService.getModels(loadFromService);
            }

            return this.modelService.getModels(loadFromService)
                .then(function (modelResults) {
                    loadFromCache.forEach(function (id) {
                        modelResults[id] = this.cacheService.get(id);
                    }, this);
                    return modelResults;
                }.bind(this));
        };

        return CachingModelDecorator;
    }
);

